import { motion } from 'framer-motion';
import { WordReveal } from '@/components/ui/word-reveal';

export function WhyUs() {
  const benefits = [
    {
      title: 'Real-time chat',
      body: 'Talk to your Associate whenever you need. Clear, quick and traceable.',
    },
    {
      title: 'Secure uploads',
      body: 'Documents are encrypted and stored safely in the cloud via private URLs.',
    },
    {
      title: 'Transparent pricing',
      body: 'Fixed platform fee — zero hidden charges or surprise invoices.',
    },
    {
      title: 'GST-compliant invoices',
      body: 'Automatically receive GST-compliant tax invoices for all services.',
    },
    {
      title: 'Verified-only network',
      body: 'All Associates are KYC-verified, screened and professionally trusted.',
    },
    {
      title: 'Works on any device',
      body: 'Access your portal from your laptop, tablet or phone — anytime, anywhere.',
    },
  ];

  return (
    <section
      id="why"
      className="scroll-mt-20 bg-white py-20 md:py-28 border-t border-gray-100 relative"
    >
      <div className="mx-auto w-full max-w-7xl 2xl:max-w-[1400px] px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto space-y-3">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#15803d]">
            WHY ECREGI
          </span>
          <WordReveal
            as="h2"
            text="Benefits that matter to you"
            className="font-display text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl lg:text-5xl"
            stagger={0.06}
          />
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
          {benefits.map((b, idx) => (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 30, filter: 'blur(6px)' }}
              whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
              viewport={{ once: true, margin: '-5% 0px' }}
              transition={{
                duration: 0.7,
                delay: idx * 0.08,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="group relative rounded-2xl border border-gray-200/90 bg-white/95 p-6 shadow-xs backdrop-blur-md hover:border-[#15803d]/70 hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300 overflow-hidden"
            >
              {/* Background Ambient Glow Effect on Hover */}
              <div className="pointer-events-none absolute -right-12 -top-12 h-36 w-36 rounded-full bg-emerald-500/15 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              <div className="relative z-10 space-y-2">
                <h3 className="font-display text-base font-bold text-gray-900 group-hover:text-[#15803d] transition-colors leading-snug">
                  {b.title}
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed font-normal">
                  {b.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
